var React = require('react');

function HamburgerMenuIcon (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0}),React.createElement("g",{"fill":"#202945","key":1},[React.createElement("rect",{"width":"20","height":"1.9","rx":".9","key":0}),React.createElement("rect",{"y":"5.7","width":"20","height":"1.9","rx":".9","key":1}),React.createElement("rect",{"y":"11.4","width":"20","height":"1.9","rx":".9","key":2})])]);
}

HamburgerMenuIcon.defaultProps = {"width":"20","height":"14","viewBox":"0 0 20 14","fill":"none"};

module.exports = HamburgerMenuIcon;

HamburgerMenuIcon.default = HamburgerMenuIcon;
